import { useState, ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Package, 
  ShoppingCart, 
  Settings, 
  LogOut,
  Menu,
  X,
  ChevronLeft,
  Star,
  ClipboardList
} from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import styles from './Sidebar.module.css';

interface SidebarProps {
  children: ReactNode;
}

const navItems = [
  { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { path: '/productos', icon: Package, label: 'Productos' },
  { path: '/stock', icon: ClipboardList, label: 'Stock' },
  { path: '/pedidos', icon: ShoppingCart, label: 'Pedidos' },
  { path: '/fidelidad', icon: Star, label: 'Fidelidad' },
  { path: '/configuracion', icon: Settings, label: 'Configuración' },
];

export function Sidebar({ children }: SidebarProps) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const { logout } = useAuth();

  return (
    <div className={styles.layout}>
      {/* Mobile Menu Button */}
      <button 
        className={styles.mobileMenuBtn}
        onClick={() => setIsMobileOpen(!isMobileOpen)}
      >
        {isMobileOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Sidebar */}
      <aside className={`${styles.sidebar} ${isMobileOpen ? styles.mobileOpen : ''} ${isCollapsed ? styles.collapsed : ''}`}>
        <div className={styles.sidebarHeader}>
          <div className={styles.logo}>
            <span className={styles.logoIcon}>TS</span>
            {!isCollapsed && <span className={styles.logoText}>TopStore</span>}
          </div>
          <button 
            className={styles.collapseBtn}
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            <ChevronLeft size={18} className={isCollapsed ? styles.rotated : ''} />
          </button>
        </div>

        <nav className={styles.nav}>
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => 
                `${styles.navItem} ${isActive ? styles.active : ''}`
              }
              onClick={() => setIsMobileOpen(false)}
            >
              <item.icon size={20} />
              {!isCollapsed && <span>{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        <div className={styles.sidebarFooter}>
          <button className={styles.logoutBtn} onClick={logout}>
            <LogOut size={20} />
            {!isCollapsed && <span>Cerrar Sesión</span>}
          </button>
        </div>
      </aside>

      {/* Mobile Overlay */}
      {isMobileOpen && (
        <div 
          className={styles.overlay} 
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      {/* Main Content */}
      <main className={`${styles.main} ${isCollapsed ? styles.mainExpanded : ''}`}>
        {children}
      </main>
    </div>
  );
}
